<div class="row message">
  <div class="container">
    <ngb-alert *ngIf="successMessage" (click)="alertClicked()" type="success" (close)="alertClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/compra/carrito']">VER TODOS</button>
    </ngb-alert>
    <ngb-alert *ngIf="successFavoritoMessage && clientOnlyRun" (click)="alertFavoritoClicked()" type="success" (close)="alertFavoritoClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successFavoritoMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/cuenta']" [queryParams]="{tab: '2'}">VER TODOS</button>
    </ngb-alert>
  </div>
</div>
<div class="container combos paquetes">
  <!-- Combos -->
  <div *ngIf="combos && combos.length > 0">
    <div class="combos text-center">
      <div *ngIf="banners && banners.Combos" class="mt-4 pb-4 mt-md-5 pb-md-5 w-100 banner-category">
        <!-- <img class="w-100" src="https://apisina-v1.leren.com.ar/storage/images/combos-y-paquetes/combos.png" [alt]="'Banner Combos Desktop'" title="Sina"> -->
        <img class="w-100" [src]="banners.Combos" [alt]="'Banner Combos'" title="Sina">
      </div>
      <h1 *ngIf="!banners || !banners.Combos">Combos Sina</h1>
    </div>
    <div class="container">
      <div *ngIf="clientOnlyRun" class="combos-grid mt-4 pb-4 mt-md-5 pb-md-5" style="border-bottom: 1px solid #cccccc;">
        <div *ngFor="let item of combos" class="combos-grid__item">
          <app-producto-item [item]="item" [combo]="true" [sesion]="loginStatus" [mensaje]="_success" [mensajeFavorito]="_successFavorito"></app-producto-item>
        </div>
      </div>
    </div>
  </div>
  <!-- Paquetes -->
  <div *ngIf="paquetes && paquetes.length > 0">
    <div class="paquetes text-center">
      <div *ngIf="banners && banners.Paquetes" class="mt-4 pb-4 mt-md-5 pb-md-5 w-100 banner-category">
        <!-- <img class="w-100" src="https://apisina-v1.leren.com.ar/storage/images/combos-y-paquetes/paquetes.png" [alt]="'Banner Combos Desktop'" title="Sina"> -->
        <img class="w-100" [src]="banners.Paquetes" [alt]="'Banner Combos'" title="Sina">
      </div>
      <h1 *ngIf="!banners || !banners.Paquetes">Paquetes Sina</h1>
    </div>
    <div class="container">
      <div *ngIf="clientOnlyRun" class="combos-grid mt-4 pb-4 mt-md-5 pb-md-5" style="border-bottom: 1px solid #cccccc;">
        <div *ngFor="let item of paquetes" class="combos-grid__item">
          <app-paquete-item [item]="item" [sesion]="loginStatus" [mensaje]="_success"></app-paquete-item>
        </div>
      </div>
    </div>
  </div>
</div>
